import React from 'react';


export default function About() {
    return (
        <section  style={{width:'90%',height:'auto',textAlign:'center',color:'#ffff'}}>
            <article><h1>Hello, I'm Barbaro and after having graduated from technical school in Cuba for a long time, my job was to fix desktop computers, but from a very young age I felt the desire to achieve through programming logic make my dreams come true but until now I had been able For reasons contrary to my will, since I really enjoy working with groups of people who are on the same page, therefore I have nothing left to say, thank you very much  <a href='https://www.thinkful.com/bootcamp/web-development/flexible/'>ThinkFull</a> for giving me the opportunity</h1></article>
        </section>
    )
}